<template>
  <div class="engineering">
    <el-container>
      <el-header>
        <el-form
          class="engineeringForm"
          :inline="true"
          :model="dataForm"
          label-width="100px"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label-width="80px" label="项目部：">
                <el-select
                  v-model="dataForm.deptId"
                  placeholder="请选择项目部"
                  @change="getProjectList"
                >
                  <el-option
                    :label="deptItem.applyDeptName"
                    :value="deptItem.applyDeptId"
                    v-for="(deptItem, deptIndex) in deptList"
                    :key="'deptItem' + deptIndex"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="80px" label="项目名称：">
                <el-select
                  v-model="dataForm.projectId"
                  placeholder="请选择项目名称"
                >
                  <el-option
                    :label="projectItem.name"
                    :value="projectItem.id"
                    v-for="(projectItem, projectIndex) in projectList"
                    :key="'projectItem' + projectIndex"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="btnRight">
              <el-form-item class="btnList">
                <el-button type="primary" @click="initData()">查 询</el-button>
                <el-button type="info" @click="reset()">重 置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="24">
            <div class="operatePanel">
              <!-- <el-button
                                    v-if="btnAuthorize.approve.btnEnable"
                                    type="primary"
                                    @click="handleSelectSubmitClick()"
                            >批量提交审批</el-button> -->
              <el-button
                v-if="btnAuthorize.allSave.btnEnable"
                style="margin-top: 10px; margin-left: 0px"
                type="primary"
                @click="handleAllSaveClick()"
                >保存</el-button
              >
              <el-button
                v-if="btnAuthorize.export.btnEnable"
                type="primary"
                icon="el-icon-download"
                @click="exportBtn()"
                >导出</el-button
              >
              <el-button
                v-if="btnAuthorize.create.btnEnable"
                type="primary"
                icon="el-icon-download"
                @click="handleAddBillClick(dataForm)"
                >新增细目</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
          v-loading="loading"
          element-loading-background="transparent"
          class="bueatyScroll"
          ref="dataTable"
          :data="engineerList"
          :span-method="spanArrayMethod"
          @selection-change="handleSelectionChange"
          highlight-current-row
          size="mini"
          height="100%"
          border
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- <el-table-column :fixed="true" label="细目信息（总包）" width="160px"
                                     :show-overflow-tooltip="true">
                        <el-table-column fixed="left" width="80px" prop="subCategoryName" label="细目名称"></el-table-column>
                        <el-table-column fixed="left" width="80px" prop="subCategoryNo" label="细目号"
                                         :show-overflow-tooltip="true"></el-table-column>
                    </el-table-column> -->
          <el-table-column
            prop="partyBName"
            label="合作单位"
            :fixed="true"
            width="120px"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.partyBName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="劳务" :show-overflow-tooltip="true">
            <el-table-column
              prop="laborItem_subCategoryName"
              label="细目名称"
              width="150px"
            ></el-table-column>
            <el-table-column
              prop="laborItem_subCategoryNo"
              label="细目号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="单位" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.laborItem_unit"
                  @blur="setValue(scope.row, 2)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="150px" prop="laborItem_unitPrice">
              <!-- <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.laborItem_unitPrice"
                  @blur="setValue(scope.row, 2)"
                ></el-input>
              </template> -->
            </el-table-column>
            <el-table-column label="是否正式单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-checkbox
                  v-model="scope.row.laborItem_unitPriceTypeBool"
                  style="z-index: 0"
                  :checked="scope.row.laborItem_unitPriceTypeBool"
                  @change="setValue(scope.row, 2)"
                  >正式单价</el-checkbox
                >
              </template>
            </el-table-column>
            <el-table-column label="税率（%）" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.laborItem_taxRate"
                  @blur="setValue(scope.row, 2)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="中标裸税单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.laborItem_bidPrice"
                  @blur="setValue(scope.row, 2)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.laborItem_unitCount"
                  @blur="setValue(scope.row, 2)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.laborItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.laborItem_remark"
                  @blur="setValue(scope.row, 2)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="laborItem_unitSumPrice"
              label="合价"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="laborItem_bidSumPrice"
              label="中标裸税合价"
              :show-overflow-tooltip="true"
              width="150px"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="材料" :show-overflow-tooltip="true">
            <el-table-column
              prop="materialItem_productName"
              label="存货名称"
              width="150px"
            ></el-table-column>
            <el-table-column
              prop="materialItem_productNumber"
              label="存货编码"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="materialItem_model"
              label="规格型号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="单位" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.materialItem_unit"
                  @blur="setValue(scope.row, 3)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="150px"  prop="materialItem_unitPrice">
              <!-- <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.materialItem_unitPrice"
                  @blur="setValue(scope.row, 3)"
                ></el-input>
              </template> -->
            </el-table-column>
            <el-table-column label="是否正式单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-checkbox
                  v-model="scope.row.materialItem_unitPriceTypeBool"
                  style="z-index: 0"
                  :checked="scope.row.materialItem_unitPriceTypeBool"
                  @change="setValue(scope.row, 3)"
                  >正式单价</el-checkbox
                >
              </template>
            </el-table-column>
            <el-table-column label="税率（%）" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.materialItem_taxRate"
                  @blur="setValue(scope.row, 3)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="中标裸税单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.materialItem_bidPrice"
                  @blur="setValue(scope.row, 3)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.materialItem_unitCount"
                  @blur="setValue(scope.row, 3)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.materialItem_productName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.materialItem_remark"
                  @blur="setValue(scope.row, 3)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="materialItem_unitSumPrice"
              label="合价"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="materialItem_bidSumPrice"
              label="中标裸税合价"
              :show-overflow-tooltip="true"
              width="150px"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="机械" :show-overflow-tooltip="true">
            <el-table-column
              prop="machineItem_subCategoryName"
              label="细目名称"
              width="150px"
            ></el-table-column>
            <el-table-column
              prop="machineItem_subCategoryNo"
              label="细目号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="单位" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.machineItem_unit"
                  @blur="setValue(scope.row, 4)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="150px" prop="machineItem_unitPrice">
              <!-- <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.machineItem_unitPrice"
                  @blur="setValue(scope.row, 4)"
                ></el-input>
              </template> -->
            </el-table-column>
            <el-table-column label="是否正式单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-checkbox
                  v-model="scope.row.machineItem_unitPriceTypeBool"
                  style="z-index: 0"
                  :checked="scope.row.machineItem_unitPriceTypeBool"
                  @change="setValue(scope.row, 4)"
                  >正式单价</el-checkbox
                >
              </template>
            </el-table-column>
            <el-table-column label="税率（%）" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.machineItem_taxRate"
                  @blur="setValue(scope.row, 4)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="中标裸税单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.machineItem_bidPrice"
                  @blur="setValue(scope.row, 4)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.machineItem_unitCount"
                  @blur="setValue(scope.row, 4)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.machineItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.machineItem_remark"
                  @blur="setValue(scope.row, 4)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="machineItem_unitSumPrice"
              label="合价"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="machineItem_bidSumPrice"
              label="中标裸税合价"
              :show-overflow-tooltip="true"
              width="150px"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="其他" :show-overflow-tooltip="true">
            <el-table-column
              prop="otherItem_subCategoryName"
              label="细目名称"
              width="150px"
            ></el-table-column>
            <el-table-column
              prop="otherItem_subCategoryNo"
              label="细目号"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="单位" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.otherItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.otherItem_unit"
                  @blur="setValue(scope.row, 5)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="单价"
              width="150px"
              prop="otherItem_unitPrice"
            >
            </el-table-column>
            <el-table-column label="是否正式单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.otherItem_subCategoryName"
              >
                <el-checkbox
                  v-model="scope.row.otherItem_unitPriceTypeBool"
                  style="z-index: 0"
                  :checked="scope.row.otherItem_unitPriceTypeBool"
                  @change="setValue(scope.row, 5)"
                  >正式单价</el-checkbox
                >
              </template>
            </el-table-column>
            <el-table-column label="税率（%）" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.otherItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.otherItem_taxRate"
                  @blur="setValue(scope.row, 5)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="中标裸税单价" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.otherItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.otherItem_bidPrice"
                  @blur="setValue(scope.row, 5)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.otherItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.otherItem_unitCount"
                  @blur="setValue(scope.row, 5)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="150px">
              <template
                slot-scope="scope"
                v-if="scope.row.otherItem_subCategoryName"
              >
                <el-input
                  size="mini"
                  v-model="scope.row.otherItem_remark"
                  @blur="setValue(scope.row, 5)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="otherItem_unitSumPrice"
              label="合价"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="otherItem_bidSumPrice"
              label="中标裸税合价"
              :show-overflow-tooltip="true"
              width="150px"
            ></el-table-column>
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="合计"
            :show-overflow-tooltip="true"
          >
            <el-table-column
              prop="unit_Price"
              label="单价"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="total_Price"
              label="合计"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="bidSum_Price"
              label="中标裸税合价"
              :show-overflow-tooltip="true"
              width="150px"
            ></el-table-column>
          </el-table-column>

          <!-- <el-table-column prop="approveStatusShow" label="审核状态"
                                     :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column label="操作" fixed="right" width="140px">
            <template slot-scope="scope">
              <!-- <el-button
                @click="handleSaveClick(scope.row)"
                type="text"
                size="small"
                >保存</el-button
              > -->
              <el-button
                @click="handleAddDetailClick(scope.row, 2)"
                type="text"
                size="small"
                >新增细目</el-button
              >
              <el-button
                @click="handleDeleteClick(scope.row)"
                type="text"
                size="small"
                >删除细目</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <!-- <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="dataForm.pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="dataForm.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer> -->
    </el-container>

    <add-detail
      v-if="addVisible"
      ref="addDetail"
      @refreshDataList="query"
    ></add-detail>
  </div>
</template>

<script>
import { measureMethod, getJBXXTableData } from "../spanMethod";
import {  measureModifyValue } from "../modifyValue";
import addDetail from "./add-detail";
import { getProjectListService } from "@/services/invoiceServices";
import { getDeptListService } from "../../../services/engineering";
import {
  queryMeasureListService,
  deleteOtherItemsService,
  saveOtherBatchService,
  saveMulOtherBatchService, //批量暂存
  exportMeasureService,
} from "../../../services/feeServices";
import { exportExcelService2 } from "../../../services/commonService";
import { Loading } from "element-ui";
export default {
  name: "index",
  data() {
    return {
      checked: false,
      dataForm: {
        feeType: "MEASURE",
        deptId: "",
        projectId: "",
        pageIndex: 1,
        pageSize: 100,
      },
      total: 0,
      showAdvanceFilter: false,

      deptList: [], //项目部列表
      projectList: [], //项目列表

      engineerList: [],
      actualEngineerList: [],

      multipleSelection: [],

      isFirst: true,
      addVisible: false, //新增细目

      btnAuthorize: {
        export: { key: "export", btnEnable: false },
        create: { key: "create", btnEnable: false },
        allSave: { key: "allSave", btnEnable: false },
      },
      loading: false,
    };
  },
  components: {
    addDetail,
  },
  methods: {
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getDeptList();
      if (this.dataForm.projectId) {
        this.initData();
      }
    },
    /**
     *  获取项目部列表
     * */
    getDeptList() {
      getDeptListService()
        .then((res) => {
          if (res.code == 10000000) {
            this.deptList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    /**
     * 查询项目列表
     * */
    getProjectList() {
      this.dataForm.projectId = "";
      let paramsData = {
        deptId: this.dataForm.deptId,
      };
      getProjectListService(paramsData)
        .then((res) => {
          if (res.code == 10000000) {
            this.projectList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    /**
     * 查询列表数据
     * */
    initData() {
      if (!this.dataForm.projectId) {
        this.$message.error("请选择项目名称");
        return;
      }
      this.loading = true;
      this.query();
    },
    query() {
      let paramsData = {
        ...this.dataForm,
      };
      queryMeasureListService(paramsData)
        .then((res) => {
          if (res.code == 10000000) {
            if (!res.data||res.data.length<=0) {
              this.engineerList =[]
              this.$message.warning("暂无数据");
              this.loading = false;
              return
            }
            let params = {
              ...res.data,
            };
            let list = [];
            params.approveStatusEnum = "READY";
            params.laborActList = [];
            params.machineActList = [];
            params.materialActList = [];
            params.otherActList = [];
            list = res.data.partyActList.map((item) => {
              item = {
                ...res.data,
                ...item,
              };
              item.laborActList = [...item.laborActList];
              item.machineActList = [...item.machineActList];
              item.materialActList = [...item.materialActList];
              item.otherActList = [...item.otherActList];
              return item;
            });
            this.actualEngineerList = list;
            this.engineerList = measureMethod(list);

            this.$forceUpdate();
            this.$nextTick(() => {
              this.loading = false;
            });
            this.total = res.total;
            // if (this.isFirst) {
            //   this.$nextTick(() => {
            //     this.childHeight4 =
            //       this.$refs.dataTable.$el.childNodes[4].offsetHeight -
            //       12 +
            //       "px";
            //     this.childHeight5 =
            //       this.$refs.dataTable.$el.childNodes[5].offsetHeight -
            //       6 +
            //       "px";
            //     this.$refs.dataTable.$el.childNodes[4].style.height =
            //       this.childHeight4;
            //     this.$refs.dataTable.$el.childNodes[5].style.height =
            //       this.childHeight5;
            //     this.$refs.dataTable.$el.childNodes[5].style.top = "-6px";
            //     this.$refs.dataTable.$el.childNodes[5].style.zIndex = "0";
            //     this.isFirst = false;
            //   });
            // } else {
            //   this.$refs.dataTable.$el.childNodes[4].style.height =
            //     this.childHeight4;
            //   this.$refs.dataTable.$el.childNodes[5].style.height =
            //     this.childHeight5;
            //   this.$refs.dataTable.$el.childNodes[5].style.top = "-6px";
            //   this.$refs.dataTable.$el.childNodes[5].style.zIndex = "0";
            // }
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
          this.loading = false;
        });
    },
    reset() {
      this.dataForm = {
        deptId: "",
        projectId: "",
        approveUserId: "",
        pageIndex: 1,
        pageSize: 10,
      };
      this.total = 0;
      this.engineerList = [];
      this.actualEngineerList = [];
      this.projectList = [];
    },
    //选中的值
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //通过措施费上方按钮新增细目
    handleAddBillClick(item) {
      if (!this.dataForm.projectId) {
        this.$message.error("请选择项目名称");
        return;
      }
      if (item.approveStatusDisplayName == "待审核") {
        this.$message.error("措施费已开始审批，不允许更新");
        return;
      }
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs.addDetail.init();
        this.$refs.addDetail.id = '';
        this.$refs.addDetail.titleIndex = 2; 
        this.$refs.addDetail.projectId = this.dataForm.projectId;
      });
    },
    //新增细目
    handleAddDetailClick(row, index) {
      if (row.approveStatusShow == "待审核") {
        this.$message.error("措施费已开始审批，不允许更新");
        return;
      }
      // this.handleSaveClick(row, 1, index);
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs.addDetail.init();
        this.$refs.addDetail.id = row.id;
        this.$refs.addDetail.partyBId = row.partyBId;
        this.$refs.addDetail.partyBName = row.partyBName;
        this.$refs.addDetail.titleIndex = index;//2措施费
      });
    },
    //删除细目
    handleDeleteClick(row) {
      // if (row.approveStatusShow == "待审核") {
      //   this.$message.error("措施费已开始审批，不允许更新");
      //   return;
      // }
      // this.handleSaveClick(row, 2);
      this.bus.$emit("navMenuChange", {
        routeId: "directDeleteDetail",
        routeParam: {
          id: row.id,
          partyBId: row.partyBId,
          type: "MEASURE",
        },
      });
    },
    //删除工程量清单
    DelectOtherItem(row) {
      if (row.approveStatusShow == "待审核") {
        this.$message.error("措施费已开始审批，不允许更新");
        return;
      }

      let param = {
        // currentUserId: 1 //sessionStorage.getItem("userCode"),
      };
      param.id = row.id;
      this.$confirm("确认删除该条清单数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        deleteOtherItemsService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.initData();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },
    //暂存
    handleSaveClick(row, noMessage = false, titleIndex = null) {
      if (row.approveStatusShow == "待审核") {
        this.$message.error("事中成本已开始审批，不允许更新");
        return;
      }
      let obj = this.actualEngineerList[row.index];
      let params = {
        ...obj,
      };
      params.approveStatusEnum = "READY";
      params.laborActList = [];
      params.machineActList = [];
      params.materialActList = [];
      params.otherActList = [];
      obj.partyActList.map((item) => {
        params.laborActList = [...params.laborActList, ...item.laborActList];
        params.machineActList = [
          ...params.machineActList,
          ...item.machineActList,
        ];
        params.materialActList = [
          ...params.materialActList,
          ...item.materialActList,
        ];
        // params.otherActList = [...params.otherActList, ...item.otherActList];
      });
      saveOtherBatchService(params)
        .then((res) => {
          if (res.code == 10000000) {
            if (!noMessage) {
              this.$message.success("暂存成功");
              this.initData();
            } else {
              if (noMessage == 1) {
                this.addVisible = true;
                this.$nextTick(() => {
                  this.$refs.addDetail.id = row.id;
                  this.$refs.addDetail.titleIndex = titleIndex;
                  this.$refs.addDetail.init();
                });
              } else if (noMessage == 2) {
                this.bus.$emit("navMenuChange", {
                  routeId: "directDeleteDetail",
                  routeParam: {
                    id: row.id,
                  },
                });
              } else if (noMessage == 3) {
                this.bus.$emit("navMenuChange", {
                  routeId: "inTheHistoryEdition",
                  routeParam: {
                    id: row.id,
                  },
                });
              } else if (noMessage == 4) {
                this.bus.$emit("navMenuChange", {
                  routeId: "inTheInfoDetails",
                  routeParam: {
                    id: row.id,
                    index: 1,
                  },
                });
              } else if (noMessage == 5) {
                this.initData();
              }
            }
          } else {
            if (!noMessage) {
              this.$message.error(res.msg);
            }
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //批量暂存
    handleAllSaveClick(noMessage = false) {
      if (!this.dataForm.projectId) {
        this.$message.error("请选择项目名称");
        return;
      }
      saveMulOtherBatchService(this.actualEngineerList)
        .then((res) => {
          if (res.code == 10000000) {
            if (!noMessage) {
              this.$message.success("保存成功");
              this.initData();
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },

    //查看详情
    handleInfoDetailsClick(row) {
      if (row.approveStatusShow == "待审核") {
        this.bus.$emit("navMenuChange", {
          routeId: "inTheInfoDetails",
          routeParam: {
            id: row.id,
            index: 1,
          },
        });
      } else {
        this.handleSaveClick(row, 4);
      }
    },
    /***
     * 导出
     */
    exportBtn() {
      if (!this.dataForm.projectId) {
        this.$message.error("请先选择项目名称后再导出！");
        return;
      }
      let loading = Loading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.5)",
      });
      let params = {
        ...this.dataForm,
      };
      exportMeasureService(params)
        .then((res) => {
          loading.close();
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$message.success("导出成功");
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          loading.close();
          this.$message.error("网络请求失败");
        });
    },
    //设置数值
    setValue(item, type) {
      if (item.approveStatusShow == "待审核") {
        this.$message.error("措施费已开始审批，不允许更新");
        return;
      }
      this.actualEngineerList =  measureModifyValue(
        this.actualEngineerList,
        item,
        type
      );
      this.engineerList = measureMethod(this.actualEngineerList);
      // this.$nextTick(() => {
      //   this.loading = true;
      //   this.handleSaveClick(item, 5);
      // });
    },
    // 分页改变事件
    handleCurrentChange(page) {
      this.dataForm.pageIndex = page;
      this.initData();
    },
    // 分页显示数量改变事件
    handleSizeChange(rows) {
      this.dataForm.pageIndex = 1;
      this.dataForm.pageSize = rows;
      this.initData();
    },
    //合并表格条件
    spanArrayMethod({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex <= 1 || (columnIndex >= 48 && columnIndex <= 50)) {
      //   const _row = getJBXXTableData(this.engineerList).one[rowIndex];
      //   const _col = _row > 0 ? 1 : 0;
      //   return {
      //     rowspan: _row,
      //     colspan: _col,
      //   };
      // }
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex === 47 ||
        columnIndex === 48 ||
        columnIndex === 49 ||
        columnIndex === 50
      ) {
        const _row = getJBXXTableData(this.engineerList).two[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.engineering {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  /deep/.engineeringForm {
    .el-form-item {
      margin-top: 5px;
    }
  }
  .operatePanel {
    margin-top: 5px !important;
  }
}
.btnRight {
  display: flex;
  justify-content: flex-end;
}
/deep/.el-table {
  th > .cell {
    text-align: center;
  }
  .cell.el-tooltip {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }
}
.statisticsList {
  display: flex;
  border: 1px solid #e6e6e6;
  .statisticsItem {
    width: 12%;
    .statisticsTxt {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
      font-size: 12px;
    }
    .statisticsNum {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #e6e6e6;
    }
  }
}
/deep/.bueatyScroll {
        .el-table__body-wrapper{
          height: calc(100% - 76px) !important;
        }
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;
        }
        .el-scrollbar__wrap::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;
        }
        .el-table__fixed{
            height: calc(100% - 12px) !important;
        }
        .el-table__fixed-right{
            height: calc(100% - 12px) !important;
        }
    }
</style>
